<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app">
		<router-view></router-view>

		<v-tour name="dashboardTour" :steps="steps" :options="tourOption" :callbacks="cb"></v-tour>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'

export default {
  data() {
    return {
			cb: {
				onStart: this.startCb,
				onNextStep: this.nextCb,
				onStop: this.stopCb
			},
			tourOption: {
				// startTimeout: 2,
					labels: {
						buttonSkip: 'Skip Tour',
						buttonPrevious: 'Precedente',
						buttonNext: 'Sucessivo',
						buttonStop: 'Concludere'
				}
			},
			steps: [
				{
					target: '.v-step-0',  // We're using document.querySelector() under the hood
					// header: {
					//   title: 'Benvenuto nel CRM Cedascom',
					// },
					content: `Scopri tutte le funzionalità del <strong>CRM Cedascom</strong>.`
				},
				{
					target: '.v-step-1',
					content: 'Clicca sul pulsante per restringere il menù e andando sull\'icona di ogni sezione potrai rivedere i suoi contenuti.'
				},
				{
					target: '.v-step-2',
					content: 'Qui trovi tutte le sezione per cui sei abilitato, le sezione con il simbolo > mostrano altre voci di quella sezione.',
					params: {
						placement: 'right',
					}
				},
				{
					target: '.v-step-3',
					content: 'Le percentuali delle tue attività indicano quante attività dovrai ancora svolgere e quelle dei tuoi collaboratori.',
					params: {
						enableScrolling: false
					}
				},
				{
					target: '.v-step-4',
					content: 'cliccando sull\'icona puoi cambiare le impostazioni del tuo profilo, aggiungere e visualizzare delle note (tasks) oppure uscire dal CRM.'
				},
				{
					target: '.v-step-5',
					content: 'in questa sezione sarai sempre aggiornato sullo stato dei tuoi lead, delle tue attività e gli ultimi documenti che sono stati creati.',
					params: {
						placement: 'top',
						enableScrolling: false
					}
				},
				{
					target: '.v-step-6',
					content: 'In questa sezione puoi travare tutte le aziende di Cedascom, inoltre puoi crearne di nuove e visualizzare tutte le informazioni necessarie.'
				},
				{
					target: '.v-step-7',
					content: 'Puoi scegliere di visualizzare le aziende in base al loro stato, inoltre puoi ricercarle per i campi indicati dalla vignetta.',
					params: {
						enableScrolling: false
					}
				},
				{
					target: '.v-step-8',
					content: 'Clicca questa icona per creare un\'azienda nuova ricorda sempre che per creare un contatto utilizza l\'apposita sezione invece hai i dati di un\'azienda sei nel posto giusto.',
					params: {
						enableScrolling: false
					}
				},
				{
					target: '.v-step-9',
					content: 'qui vengono visualizzate le informazioni principali dell\'azienda, l\'icona verde nella colonna tipo indica che l\'azienda è associata e i simboli indicato società di persone o di capitali. Nella colonna servizi vengono illustrati i servizi attivi e avvicinandosi vengono mostrati i nomi. Cliccando in ogni parte potrai visualizzare le ubicazioni, i contatti, i documenti, lead e le attività dell\'azienda selezionata.',
					params: {
						enableScrolling: false
					}
				},
				{
					target: '.v-step-10',
					content: 'Ho finito il mio tour, ogni qualvolta tu voglia avere informazioni cliccami.'
				}
			]
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
    // '$route' (to, from) {
    //   console.log('Route changed from ' + from.path + ' to ' + to.path);
    // }
  },
  async created() {
    // try {
    //   await this.$auth.renewTokens();
    // } catch (e) {
    //   console.log(e);
    // }
    return null
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
		startMyTour() {
			if (localStorage.utente_tour == "true") {
				setTimeout(() => this.$tours['dashboardTour'].start(), 2500);
			}
		},
		stopCb() {
			axios.post(process.env.VUE_APP_BACKEND_API+'/utente/tour', {tour: false}, {
				headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json', },
				withCredentials: true,
			}) .then(response => {
				localStorage['utente_tour'] = response.data.tour
			})
			.catch(e => console.log(e))
		},
		startCb() {
			this.$router.push("/")
		},
		nextCb(currentStep) {
			if (currentStep === 5) {
				this.$router.push("aziende")
			}
		},
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);

		this.startMyTour()
  },
// CAN'T WATCH ON localStorage, NOT REACTIVE https://stackoverflow.com/questions/45865172/vuejs-how-to-watch-a-value-in-localstorage/45873478
	// watch: {
  //   localStorage.utente_tour() {
  //     if (localStorage.utente_tour) {
	// 			this.$tours['myTour'].start()
	// 		}
  //   },
	// },
	// async updated() {
  //   await this.$nextTick() // or try to place it in directly into mounted()
	// 	// if (!localStorage.endedTour && localStorage.utente_tour) {
	// 	if (localStorage.utente_tour) {
	// 		this.$tours['myTour'].start()
	// 	}
	// },
	// created : function () {
	// 	this.$tours['myTour'].start()
	// },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
}

</script>
